import feeds from "./modules/feeds"

export default {
    modules: {
        feeds
    }
}
